// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25337
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25337
import { eventTrackingUtils } from "@/utils/eventTrackingUtils";
export const PageId = Object.freeze({
  Review_Edit: "Review_Edit",
});

interface IPVTrackParamsRecord {
  /** 评价编辑页 */
  Review_Edit: {
    /** 订单id  */
    orderId: string;
  };
}

const sendPv = {
  /** PV-评价编辑页 */
  Review_Edit: (page_param: IPVTrackParamsRecord["Review_Edit"]) => {
    eventTrackingUtils.submitPV({ page_id: PageId.Review_Edit, page_param });
  },
};

interface IExpoTrackParamsRecord {
  /** 评分曝光 */
  Review_Edit_Star_Expo: {
    /** 订单id  */
    orderId: string;
    /** 商品id  */
    skuid: string;
    /** 标题  */
    title: string;
  };
  /** 上传图片或视频曝光 */
  Review_Edit_AddPhoto_Expo: {
    /** 订单id  */
    orderId: string;
    /** 商品id  */
    skuid: string;
  };
  /** 发布按钮曝光 */
  Review_Edit_Publish_Expo: {
    /** 订单id  */
    orderId: string;
  };
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord, string>> = Object.freeze({
  /** 评分曝光 */
  Review_Edit_Star_Expo: "Review_Edit_Star_Expo",
  /** 上传图片或视频曝光 */
  Review_Edit_AddPhoto_Expo: "Review_Edit_AddPhoto_Expo",
  /** 发布按钮曝光 */
  Review_Edit_Publish_Expo: "Review_Edit_Publish_Expo",
});

interface IClickTrackParamsRecord {
  /** 评分点击 */
  Review_Edit_Star: {
    /** 订单id  */
    orderId: string;
    /** 商品id  */
    skuid: string;
    /** 标题  */
    title: string;
  };
  /** 上传图片或视频点击 */
  Review_Edit_AddPhoto: {
    /** 订单id  */
    orderId: string;
    /** 商品id  */
    skuid: string;
  };
  /** 发布按钮点击 */
  Review_Edit_Publish: {
    /** 订单id  */
    orderId: string;
  };
}

const sendClickTrack = {
  /** 点击事件上报-评分点击 */
  Review_Edit_Star: (json_param: IClickTrackParamsRecord["Review_Edit_Star"]) => {
    eventTrackingUtils.submitCL({ event_id: "Review_Edit_Star", json_param });
  },
  /** 点击事件上报-上传图片或视频点击 */
  Review_Edit_AddPhoto: (json_param: IClickTrackParamsRecord["Review_Edit_AddPhoto"]) => {
    eventTrackingUtils.submitCL({ event_id: "Review_Edit_AddPhoto", json_param });
  },
  /** 点击事件上报-发布按钮点击 */
  Review_Edit_Publish: (json_param: IClickTrackParamsRecord["Review_Edit_Publish"]) => {
    eventTrackingUtils.submitCL({ event_id: "Review_Edit_Publish", json_param });
  },
};

export { EXPOSURE_RECORD, sendClickTrack, sendPv };
export type { IExpoTrackParamsRecord };
